import React, { Component } from 'react';
import $ from 'jquery';
import _ from 'underscore';

import { changeMapData } from '../actions/index';

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

class PropertyEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modifiedFeature : false,
      newProperty : ''
    }
  }

  componentDidMount() {
    var currentGeometry = JSON.parse(JSON.stringify(this.props.currentGeometry))
    this.setState({modifiedFeature:currentGeometry});
  }

  changeProperty(key, e) {
    var thisFeature = JSON.parse(JSON.stringify(this.state.modifiedFeature));
    thisFeature.properties[key] = e.target.value;
    this.setState({modifiedFeature : thisFeature});
  }

  addProperty(e) {
    e.preventDefault();
    var thisFeature = JSON.parse(JSON.stringify(this.state.modifiedFeature));
    thisFeature.properties[this.state.newProperty] = '';
    this.setState({newProperty:'',modifiedFeature:thisFeature});
  }

  removeProperty(key, e) {
    e.preventDefault();
    var thisFeature = JSON.parse(JSON.stringify(this.state.modifiedFeature));
    delete thisFeature.properties[key];
    this.setState({newProperty:'',modifiedFeature:thisFeature});
  }

  setProperties(e) {
    e.preventDefault();
    const { modifiedFeature } = this.state;
    if(modifiedFeature) {
      var newFeatures = [];
      this.props.mapObject.mapData.forEach(function(feature) {
        if(feature.id===modifiedFeature.id) {
          newFeatures.push(modifiedFeature);
        } else {
          newFeatures.push(feature);
        }
      })
      this.props.dispatch(changeMapData(newFeatures));
    }
    this.props.closePropertyEditor();
  }

  render() {

    var currentGeometryPropertiesAsArray = [];
    for (var prop in this.state.modifiedFeature.properties) {
      if(prop!=='opacity'&&prop!=='rgb'&&prop!=='description'&&prop!=='popup_open'&&prop!=='marker_icon_url'&&prop!=='marker_title'&&prop!=='category'&&prop!=='marker_icon_anchor'&&prop!=='color') {
        currentGeometryPropertiesAsArray.push({
          key : prop,
          value : this.state.modifiedFeature.properties[prop]
        })
      }
    }
    console.log(currentGeometryPropertiesAsArray);

    return (
      <div style={{width:window.innerWidth-160,height:window.innerHeight,marginLeft:-($('#wp-mapbox-gl-js-geometry-options').offset().left-160),marginTop:-($('#wp-mapbox-gl-js-geometry-options').offset().top+($(".edit-post-layout__content").length ? $(".edit-post-layout__content").scrollTop() : 0))}} className={"wp-mapbox-gl-js-property-editor now-active"}>
        <div style={{height:window.innerHeight/1.5}} className="wp-mapbox-gl-js-property-editor-container">
          <h3>Property Editor</h3>
          <p>Here, you can edit the properties attached to your feature. The properties built into WP Mapbox GL JS are not listed here.</p>
          <p><strong>This is an advanced feature. Get in touch if you have trouble with it.</strong></p>
          <table>
            <tbody>
              {currentGeometryPropertiesAsArray.map((prop, index) => {
                return (
                  <tr key={"table-row-"+index}>
                    <td><strong>{prop.key}</strong></td>
                    <td><input type="text" value={prop.value} onChange={this.changeProperty.bind(this,prop.key)} /></td>
                    <td>{prop.key!=='name'&&prop.key!=='description' ? <button className="button" onClick={this.removeProperty.bind(this,prop.key)}>Remove Property</button> : false }</td>
                  </tr>
                )
              })}
              <tr style={{marginTop:'20px'}}>
                <td></td>
                <td><input type="text" value={this.state.newProperty} onChange={(e) => this.setState({newProperty:e.target.value})} /></td>
                <td><button onClick={this.addProperty.bind(this)} className="button">Add Property</button></td>
              </tr>
            </tbody>
          </table>
          <div style={{marginBottom:'70px'}} className="wp_mapbox_gl_js_actions">
            <button className="button" style={{marginRight:'10px'}} onClick={(e) => { e.preventDefault(); this.props.closePropertyEditor(); }}>Cancel</button>
            <button className="button button-primary" onClick={this.setProperties.bind(this)}>Update Properties</button>
          </div>
        </div>
      </div>
    )
  }
}

export default PropertyEditor;



// WEBPACK FOOTER //
// ./src/components/PropertyEditor.js